/*
 * Copyright (C) 2017-present Connection Loops Pvt. Ltd., Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
/*
 * Author : Pratik Mohite
 * Date : 2021-03-20 23:32:34
 * Description:
 * This file contains the Constants
 */

import { ICLDropDownOptions } from "components/common";
import { IBillItems, IPartyBill } from "common_assets/types/Types";

export enum DateFilter {
  TODAY = 1,
  YESTERDAY = 2,
  THIS_WEEK = 3,
  LAST_WEEK = 4,
  THIS_MONTH = 5,
  LAST_MONTH = 6,
  THIS_QUARTER = 7,
  LAST_QUARTER = 8,
  THIS_YEAR = 9,
  LAST_YEAR = 10,
  THIS_FISCAL_YEAR = 11,
  LAST_FISCAL_YEAR = 12,
  ALL_TIME = 98,
  CUSTOM = 99,
}

export enum notificationType {
  ERROR = 0,
  SUCCESS = 1,
  WARNING = 2,
  INFO = 3,
}

/*
c 1000 = 8
r 0100 = 4
u 0010 = 2
d 0001 = 1
*/
export enum CPPermissions {
  CREATE = 8,
  READ = 4,
  UPDATE = 2,
  DELETE = 1,
}

export const preferenceConstants = {};

export const CL_DATE_FORMAT = "DD/MM/YYYY";
export const CL_TIME_FORMAT = "HH:mm:ss";
export const CL_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const DateFilterLabels = [
  { value: DateFilter.TODAY, label: "Today" },
  { value: DateFilter.YESTERDAY, label: "Yesterday" },
  { value: DateFilter.THIS_WEEK, label: "This Week" },
  { value: DateFilter.LAST_WEEK, label: "Last Week" },
  { value: DateFilter.THIS_MONTH, label: "This Month" },
  { value: DateFilter.LAST_MONTH, label: "Last Month" },
  { value: DateFilter.THIS_QUARTER, label: "This Quarter" },
  { value: DateFilter.LAST_QUARTER, label: "Last Quarter" },
  { value: DateFilter.THIS_YEAR, label: "This Calendar Year" },
  { value: DateFilter.LAST_YEAR, label: "Last Calendar Year" },
  { value: DateFilter.THIS_FISCAL_YEAR, label: "This Fiscal Year" },
  { value: DateFilter.LAST_FISCAL_YEAR, label: "Last Fiscal Year" },
  { value: DateFilter.CUSTOM, label: "Custom" },
];

export const getDateLabel = (dt: DateFilter) => {
  const v = DateFilterLabels.find((e) => e.value === dt);
  return v ? v.label : "";
};

export const ReportTypes = {
  ITEMS: "ITEMS",
  PARTY: "PARTY",
  BILL: "BILL",
  CREDIT: "CREDIT",
  WALLET: "WALLET",
  PENDING: "PENDING",
  PAYMENT: "PAYMENT",
};

export const AllOption: ICLDropDownOptions = {
  Text: "All",
  data: {},
  Id: "All",
};

export const EntityDetailsType = {
  HALLMARK: "HALLMARK",
  LESSER_MARKING: "LESSER_MARKING",
  SMART_CARD_DETAILS: "SMART_CARD_DETAILS",
  TUNCH_DETAILS: "TUNCH_DETAILS",
  LASER_SOLDERING: "LASER_SOLDERING",
  SILVER_HALL_MARKING: "SILVER_HALL_MARKING",
};

export const EntityDetailsTypeLabel: { [key: string]: string } = {
  HALLMARK: "HallMark Details",
  LESSER_MARKING: "Lesser Marking Details",
  SMART_CARD_DETAILS: "Smart Card Details",
  TUNCH_DETAILS: "Tunch Details",
  LASER_SOLDERING: "Lesser Soldering",
  SILVER_HALL_MARKING: "Silver Hall Marking Details",
};

export const BillStatusOptions: ICLDropDownOptions[] = [
  { Id: "PAID", data: {}, Text: "PAID" },
  { Id: "DUE", data: {}, Text: "DUE" },
  { Id: "DISCARDED", data: {}, Text: "DISCARDED" },
];
export const BillStatusOp = {
  PAID: "PAID",
  DUE: "DUE",
  DISCARDED: "DISCARDED",
};
export const getTotal = (bill?: IPartyBill): number => {
  let total = 0;
  if (bill) {
    bill.BillDetails.forEach((e) => {
      total += getEntityTotal(e.BillItems, e.EntityType);
    });
  }
  return parseFloat(total.toFixed(3));
};
export const getGrandTotal = (bill?: IPartyBill): number => {
  let total = getTotal(bill);
  let gst = getGst(bill);
  return parseFloat((total + gst).toFixed(3));
};
export const getDue = (bill?: IPartyBill): number => {
  let total = getGrandTotal(bill);
  let paid = getPaid(bill);
  return parseFloat((total - paid).toFixed(3));
};

export const getGst = (bill?: IPartyBill): number => {
  let total = 0;
  let Gst = 0;
  if (bill) {
    Gst = bill.Gst;
    total = (Gst / 100) * getTotal(bill);
  }
  return parseFloat(total.toFixed(3));
};
export const getDateOnly = (dt: string) => {
  if (dt) {
    try {
      let dateParts = dt.split(" ")[0].split("/");
      return dateParts[0] + dateParts[1] + dateParts[2][2] + dateParts[2][3];
    } catch (e) {
      return "";
    }
  }
  return "";
};
export const getBillNo = (party?: IPartyBill) => {
  if (party) {
    return party.BillNo + " " + getDateOnly(party.BillDt);
  }
  return "";
};

export const getEntityTotal = (entity: IBillItems[], entityType: string) => {
  let total = 0;
  if (entity && entity.length > 0) {
    entity.forEach((e) => {
      total += (e.Qty || 0) * (e.Rate || 0);
    });
  }
  return parseFloat(total.toFixed(3));
};

export const getPaid = (bill?: IPartyBill) => {
  let total = 0;
  if (bill && bill.BillPayments) {
    bill.BillPayments.forEach((e) => {
      total += e.Amount;
    });
  }
  return parseFloat(total.toFixed(3));
};
export const MODULES = {
  HOME: "HOME",
  FRANCHISE: "Franchise",
  ITEM_MASTER: "ItemMaster",
  PARTY_MASTER: "PartyMaster",
  REPORTS: "Reports",
  CONTACT: "CONTACT",
  ROLE_MANAGEMENT: "RoleManagement",
  USER_MANAGEMENT: "UserManagement",
};

export const DATE_MODE = {
  PAYMENT: "PAYMENT",
  BILL_DT: "BILL_DT",
};
